// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"168":"79786a1f","478":"a6c3cb6e","604":"3e6af3e0","613":"2189b4b7","705":"bcd53a42","823":"0a40928a"}[chunkId] + ".css";
};